module.exports = __webpack_public_path__ + "static/media/siding@2x.65616e70.jpg";